import { useState, useEffect } from 'react';
import PublicApp from './pages/PublicApp';

function isAdminRoute() {
  return window.location.pathname.startsWith('/admin');
}

// Lazy-load admin app
const AdminAppLazy = () => {
  const [AdminApp, setAdminApp] = useState<any>(null);

  useEffect(() => {
    import('./admin/AdminApp').then((mod) => {
      setAdminApp(() => mod.default);
    });
  }, []);

  if (!AdminApp) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-surface-light">
        <div className="w-8 h-8 border-4 border-content-border border-t-oak-green rounded-full animate-spin" />
      </div>
    );
  }

  return <AdminApp />;
};

export default function App() {
  const [isAdmin, setIsAdmin] = useState(isAdminRoute);

  useEffect(() => {
    const handlePopState = () => setIsAdmin(isAdminRoute());
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  if (isAdmin) {
    return <AdminAppLazy />;
  }

  return <PublicApp />;
}
